export default {
  openChangelog: {
    notes: 'Changelog button title',
    message: 'Log',
  },
  title: {
    notes: 'Changelog dialog title',
    message: 'Changelog',
  },
  model: {
    timestamp: {
      notes: 'Changelog Timestamp column title',
      message: 'Timestamp modified',
    },
    context: {
      notes: 'Changelog Context (description) column title',
      message: 'Context',
    },
    value: {
      notes: 'Changelog Value column title',
      message: 'New value',
    },
  },
};
